const defaultOptions = {
  label: 'name',
  value: 'id',
  sort: false,
};

export default (collection, options = defaultOptions) => {
  if (!collection) {
    return [];
  }
  options = { ...defaultOptions, ...options };

  collection = collection.map((item) => ({
    label: item[options.label],
    value: item[options.value],
  }));

  if (options.sort) {
    return collection.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
  }

  return collection;
};
